import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import './i18n/i18n';

import './index.css';

async function readConfigWeb() {
  const response = await fetch(window.location.origin + '/config-web.json?t=' + dayjs().unix());
  const json = await response.json();
  window.sampleAppConfig = json;
  const appName = json.APP_NAME?.trim().toLowerCase();

  document.documentElement.classList.remove('brand-pixsat', 'brand-geostella');
  document.documentElement.classList.add(
    appName === 'geostella' ? 'brand-geostella' : 'brand-pixsat'
  );
  // console.log('Config loaded:', window.sampleAppConfig);
  return json;
}

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 0,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000)
    },
    mutations: {
      retry: 0
    }
  }
});

readConfigWeb().then(async () => {
  const { default: App } = await import('./App.tsx');
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  );
});
